import { TableFieldModel } from '@/model/TableList'

export const FieldHistoryTable: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'before',
    fieldName: '之前数量'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'after',
    fieldName: '之后数量'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'num',
    fieldName: '变更数量'
  }
]
